import React from 'react'
import { observer } from 'mobx-react'
import Icon from 'components/common/Icon'
import { withTranslation } from 'react-i18next'

const Rename = ({ label, error, clearError, value, onSubmit, onCancel, onChange, t }) => (
  <section onClick={e => e.stopPropagation()}>
    <label>
      <span>{label}</span>
      <form onSubmit={e => {
        e.preventDefault()
        e.stopPropagation()
        onSubmit()
      }}
      >
        <input
          type='text' className='name-input'
          value={value} onChange={e => {
            clearError()
            onChange(e)
          }}
          autoFocus
        />
        {
          error && <span className='invalid'>{error}</span>
        }
      </form>
    </label>
    <div className='button-row'>
      <button 
        className='cancel' 
        type='button' 
        onClick={e => {
          e.stopPropagation()
          onCancel()
        }}
      >
        <Icon id='fa-times' />
        {t('GLOBAL.CANCEL')}
      </button>
      <button 
        className='ok' 
        type='button' 
        onClick={e => {
          e.stopPropagation()
          onSubmit()
        }}
      >
        <Icon id='fa-check' />
        {t('GLOBAL.RENAME')}
      </button>
    </div>
  </section>
)

export default withTranslation()(observer(Rename))
